@if (isActive) {
  <button
    type="button"
    class="button icon-button"
    [matTooltip]="isPending ? ('devices.detail.pending' | translate) : null"
    [class.transparent]="isActive && transparent"
    [class.isPending]="isPending"
    [disabled]="disabled"
    [class.primary-button]="isActive"
    [class]="size"
    (click)="onTriggerDeviceAction(!isActive, $event)"
  >
    <app-text-with-icon [vertical]="vertical" name="ic_dashboard">{{
      "devices.active.short" | translate
    }}</app-text-with-icon>
  </button>
} @else {
  <button
    type="button"
    class="button icon-button"
    [matTooltip]="isPending ? ('devices.detail.pending' | translate) : null"
    [class.isPending]="isPending"
    [disabled]="disabled"
    [class]="size"
    (click)="onTriggerDeviceAction(true, $event)"
  >
    <app-text-with-icon [vertical]="vertical" name="ic_valve_closed_symbol">{{
      "devices.inactive.short" | translate
    }}</app-text-with-icon>
  </button>
}
